import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import { fetchUserData } from "storage/sessionStorage";

const PrivateRoutes = ({ component: Component, ...rest }) => {
  const accessToken = fetchUserData();
  const role = localStorage.getItem("role");

  return (
    <Route
      {...rest}
      render={(props) =>
        accessToken && role ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default withRouter(PrivateRoutes);
